'use client';

import { Form, Gutter, SelectInput, useConfig, useLocale, useTranslation } from '@payloadcms/ui';
import { getRouteResolver } from '@websolutespa/payload-utils';
import React, { useEffect, useMemo, useState } from 'react';
import { LlmApp } from '../../api/types';
import './Llm.scss';
import { LlmLinksApp } from './LlmLinksApp';

export const LlmLinksClient_ = () => {
  const { t } = useTranslation<any, any>();
  const { config } = useConfig();
  const { routes, serverURL } = config;
  const locale = useLocale();
  const [apps, setApps] = useState<LlmApp[]>([]);
  const [app, setApp] = useState<LlmApp>();
  const routeResolver = getRouteResolver(config);
  // fetch apps
  useEffect(() => {
    const fetchApps = () => {
      const url = routeResolver.api(`/llmApp?pagination=false&locale=${locale}`);
      fetch(url)
        .then((response) => response.json())
        .then((apps) => {
          setApps(apps);
          if (apps && apps.length === 1) {
            setApp(apps[0]);
          }
        });
    };
    fetchApps();
  }, [locale, routes.api, serverURL]);

  const selectOptions = useMemo(() => {
    return apps.map((x) => ({
      label: x.name,
      value: x.id,
    }));
  }, [apps]);

  const onSelectDidChange = (value: string) => {
    const app = apps.find((x) => x.id === value);
    setApp(app);
    // console.log('onSelectDidChange', app);
  };

  return (
    <Gutter className="llm__container">
      <div className="llm__app">
        <Form className="llm__form">
          <SelectInput
            label={t('general:selectApp')}
            name="select"
            path="select"
            options={selectOptions}
            onChange={(option) => Array.isArray(option) ?
              null :
              onSelectDidChange(option.value as string)
            }
            value={app?.id}
          />
        </Form>
      </div>
      {app && <LlmLinksApp app={app} />}
    </Gutter>
  );
};

export const LlmLinksClient = React.memo(LlmLinksClient_);
